import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconsModule } from '../../design/icons.module';
import { BrasaToastComponent } from './toast.component';

@NgModule({
  declarations: [BrasaToastComponent],
  imports: [CommonModule, IconsModule],
  exports: [BrasaToastComponent]
})
export class ToastModule { }
